import DataDisplaysColorizedCategorizableController from "./data-displays-colorized-categorizable-controller";

export default class extends DataDisplaysColorizedCategorizableController {
  enlarge(event) {
    this.element.classList.add("in-focus")
  }

  shrink(event) {
    this.element.classList.remove("in-focus")
  }
}



// WEBPACK FOOTER //
// ./app/components/data_displays/assets/javascript/data-displays-category-dot-controller.js